import styled from 'styled-components';

export const Label = styled.label`
  &.checkbox {
    display: block;
    position: relative;
    padding-left: 20px;
    cursor: pointer;
    font-size: 14px;
    user-select: none;
    text-transform: none;

    input[type='checkbox'] {
      display: none;
    }

    input:checked ~ span {
      border: 2px solid var(--blue12);
      color: var(--blue12);
      padding: 1px 0;
    }

    span {
      width: 14px;
      height: 14px;
      display: block;
      position: absolute;
      top: 0;
      left: 0;

      font-size: 10.9px;
      color: #fff;
      font-weight: 700;
      text-align: center;

      border: 2px solid var(--blue12);
      border-radius: 3px;
      background-color: #fff;
    }

    .checkbox__label-text {
    }
  }
`;
